/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

// images import
import "../../assets/icon-16.png";
import "../../assets/icon-32.png";
import "../../assets/icon-64.png";
import "../../assets/icon-80.png";
import "../../assets/icon-128.png";
import "../../assets/logo-filled.png";

import "../../assets/img/call-conference.png";
import "../../assets/img/card.png";
import "../../assets/img/clim.png";
import "../../assets/img/default-room.jpg";
import "../../assets/img/eau.png";
import "../../assets/img/favoris.png";
import "../../assets/img/handicape.png";
import "../../assets/img/logout.png";
import "../../assets/img/meeting-icon.jpg";
import "../../assets/img/ordinateur.png";
import "../../assets/img/paperboard.png";
import "../../assets/img/pause.png";
import "../../assets/img/tableauinteractif.png";
import "../../assets/img/tele.png";
import "../../assets/img/telephone.png";
import "../../assets/img/terasse.png";
import "../../assets/img/videoconference.png";
import "../../assets/img/videopro.png";
import "../../assets/img/wifi.png";

import * as msal from "@azure/msal-browser";


var salleList;
var UIText;
var languageURL;

var contextItem;
var mailboxItem;

Office.initialize = function (reason) {
  contextItem = Office.context;
  mailboxItem = Office.context.mailbox.item;
};

const TENANT_DOMAIN_MAP = {
  "2670ac34-d585-42b0-9700-60ec59689f1e": "dev",
  "b966bc41-dcdf-4ed0-ae37-ab201d99652c": "onet",
};

function decodeJwt(token) {
  const payload = token.split('.')[1];
  const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
  return JSON.parse(decoded);
}

Office.onReady(async (info) => {

  const msalInstance = new msal.PublicClientApplication({
    auth: {
      clientId: "570ed09c-e3ba-4c97-8e0e-136378a515d6",
      authority: "https://login.microsoftonline.com/common",
      redirectUri: "https://outlook.camileia.com/home.html"
    }
  });
  await msalInstance.initialize();

  await msalInstance.handleRedirectPromise();

  if(localStorage.getItem('token') == null)
  {
    $('#username').val(contextItem.mailbox.userProfile.emailAddress);

    try {
      // Récupère le compte connecté
      const accounts = msalInstance.getAllAccounts();
      const request = {
        scopes: ["api://570ed09c-e3ba-4c97-8e0e-136378a515d6/access_as_user"],
        account: accounts.length > 0 ? accounts[0] : null,
        forceRefresh: true
      };

      let response;
      try {
        if (accounts.length === 0) throw new Error("no account");
        response = await msalInstance.acquireTokenSilent(request);
      } catch {
        response = await msalInstance.acquireTokenPopup(request);
      }

      const entraToken = response.accessToken;

      const decoded = decodeJwt(entraToken);
      const tenantId = decoded.tid;

      if (!tenantId) {
        throw new Error("Tenant ID introuvable dans le token");
      }

      const domain = TENANT_DOMAIN_MAP[tenantId];

      if (!domain) {
        throw new Error("Tenant non autorisé");
      }

      console.log(domain);
      console.log(decoded);

      var url_domain = "https://"+domain+".camileia.com/api/outlook/";
      var href = url_domain+"connexion_sso";

      var table = {
        token: entraToken
      };

      $.ajax({
        type: "GET",
        dataType: 'jsonp',
        url: href,
        cors: true ,
        contentType:'application/json',
        data:table,
        success: function(json) {
          if(json.etat == true)
          {
            localStorage.setItem('url_domain', url_domain);
            localStorage.setItem('token', json.token);
            localStorage.setItem('idcontact', json.idcontact);
            localStorage.setItem('contact', json.contact);
            localStorage.setItem('idsite', json.idsite);

            console.log("Connexion SSO réussie");

            location.reload();
          }
          else{
            if(json.max_terminal == true)
            {
              console.log("Connexion SSO : Max Terminal");
            }
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log("Connexion SSO : internet access error");
        },
      });


    } catch (error) {
      console.error("Erreur SSO:", error);
    }
  }

  mailboxItem.addHandlerAsync(
    Office.EventType.AppointmentTimeChanged,
    function (eventResult) {resetFiltres();setSallesList(0);}
  );

  mailboxItem.addHandlerAsync(
    Office.EventType.RecipientsChanged,
    function (eventResult) {resetFiltres();setSallesList(0);}
  );
  mailboxItem.addHandlerAsync(
    Office.EventType.RecurrenceChanged,
    function (eventResult) {resetFiltres();setSallesList(0);}
  );


  mailboxItem.getItemIdAsync(function (result) {
    if (result.status !== Office.AsyncResultStatus.Succeeded) {
      console.log(`new event`);
    } else {
      console.log('existing event');

      getDateAsync(mailboxItem.start, (errStart, startDate) => {
        if (errStart) {
          console.error("Impossible de lire start:", errStart);
          // ici: fallback Graph (recommandé) ou EWS en dernier recours
          return;
        }

        getDateAsync(mailboxItem.end, (errEnd, endDate) => {
          if (errEnd) {
            console.error("Impossible de lire end:", errEnd);
            return;
          }

          var tz = tz_table.getIanaTZ(contextItem.mailbox.userProfile.timeZone);

          var startdate = Math.floor(startDate.getTime() / 1000);
          startdate = moment.unix(startdate).tz(tz);
          startdate = startdate.local().format('YYYY-MM-DDTHH:mm:ss');
          startdate = Date.parse(startdate+'Z')/1000;

          var enddate = Math.floor(endDate.getTime() / 1000);
          enddate = moment.unix(enddate).tz(tz);
          enddate = enddate.local().format('YYYY-MM-DDTHH:mm:ss');
          enddate = Date.parse(enddate+'Z')/1000;

          console.log("startdate", startdate, "enddate", enddate);

          var idcontact = localStorage.getItem('idcontact');
          var token = localStorage.getItem('token');
          var url_domain = localStorage.getItem('url_domain');
          var href = url_domain+"find/reservation";

          var table = {
            idcontact: idcontact,
            token : token,
            startdate : startdate,
            enddate : enddate,
          };

          $.ajax({
            type: "GET",
            dataType: 'jsonp',
            url: href,
            cors: true ,
            contentType:'application/json',
            data:table,
            success: function(json) {
              if(json.etat == true)
              {
                if(json.existe == true)
                {
                  localStorage.setItem('idsalle', json.idsalle);
                  localStorage.setItem('idreservation', json.idreservation);
                  localStorage.setItem('card', JSON.stringify(json.card));
                  localStorage.setItem('place_parking', json.placeparking);
                  localStorage.setItem('point_accueil', json.idpointaccueil);
                  window.location.href = "https://outlook.camileia.com/reservation.html";
                }
              }
              else{
                console.log('erreur récupération de la reservation');
                localStorage.removeItem('contact');
                localStorage.removeItem('idcontact');
                localStorage.removeItem('token');
                localStorage.removeItem('url_domain');
                localStorage.removeItem('card');
                localStorage.removeItem('point_accueil');
                localStorage.removeItem('idsite');
                localStorage.removeItem('idsalle');
                localStorage.removeItem('place_parking');
                location.reload();
              }
            }
          });

        });
      });
    }
  });

  //TRADUCTION

  var myLanguage = contextItem.displayLanguage;
  languageURL = contextItem.displayLanguage;
  UIText = UIStrings.getLocaleStrings(myLanguage);
  $("#text_bienvenue").text(UIText.text_bienvenue);
  $("#text_site").text(UIText.text_site);
  $("#text_date").text(UIText.text_date);
  $("#text_filtres").text(UIText.text_filtres);
  $("#text_salles_disponibles").text(UIText.text_salles_disponibles);
  $("#text_salles_non_disponibles").text(UIText.text_salles_non_disponibles);
  $("#show_all_salles").text(UIText.text_show_all_salles);

  $("#domain").attr("placeholder",UIText.text_choisir_le_client);
  $("#username").attr("placeholder",UIText.text_nom_utilisateur);
  $("#password").attr("placeholder",UIText.text_mot_de_passe);
  $("#connexion").text(UIText.text_connexion);


  localStorage.setItem('idsalle', null);
  localStorage.setItem('card', null);
  localStorage.setItem('place_parking', null);
  localStorage.setItem('point_accueil', null);
  localStorage.setItem('idreservation', null);

  if(localStorage.getItem('token') != null)
  {
    $('#logged_in').show();
    $('#icon_logout').show();
    $('#display_username').html(localStorage.getItem('contact'));
    setSitesList();

    $('#list_sites').on('change', function() {
      resetFiltres();
      setSallesList(0);
    });

    $(document).on('click', '.btn_reserver',function() {
      var idsalle = $(this).attr('data-idsalle');
      localStorage.setItem('idsalle', idsalle);
      window.location.href = "https://outlook.camileia.com/reservation.html";
    });

    $(document).on('click', '#show_all_salles',function() {
      resetFiltres();
      setSallesList(1);
    });

    $(document).on('click', '.filtre',function() {
      if(salleList.show_all == 0) {
        setSallesList(1,function() {
          setFilteredSallesList();
        });
      }
      else {
        setFilteredSallesList();
      }
    });



    $(document).on('click', '#icon_logout',function() {

      $('.div_loader').css('display', 'flex');

      var idcontact = localStorage.getItem('idcontact');
      var token = localStorage.getItem('token');
      var url_domain = localStorage.getItem('url_domain');
      var href = url_domain+"deconnexion";

      var table = {
        idcontact: idcontact,
        token : token,
      };

      $.ajax({
        type: "GET",
        dataType: 'jsonp',
        url: href,
        cors: true ,
        contentType:'application/json',
        data:table,
        success: function(json) {
          if(json.etat == true)
          {
            localStorage.removeItem('contact');
            localStorage.removeItem('idcontact');
            localStorage.removeItem('token');
            localStorage.removeItem('url_domain');
            localStorage.removeItem('card');
            localStorage.removeItem('point_accueil');
            localStorage.removeItem('idsite');
            localStorage.removeItem('idsalle');
            localStorage.removeItem('place_parking');
            location.reload();
          }
        }
      });
    });

    $( ".accordion" ).accordion({
      heightStyle: "content",
      collapsible: true,
      active: false,
    });

  }
  else
  {
    $('#login_form').show();
    $('#connexion').on('click', function() {
      connexion();
    });
  }

});


export async function connexion() {
  $('.div_loader').css('display', 'flex');

  var domain = $('#domain').val();
  var username = $('#username').val();
  var password = $('#password').val();

  if(domain != "" && username != "" && password != "")
  {
    var url_domain = "https://"+domain+".camileia.com/api/outlook/";

    var href = url_domain+"connexion";

    var table = {
      username: username,
      password : password,
    };

    $.ajax({
      type: "GET",
      dataType: 'jsonp',
      url: href,
      cors: true ,
      contentType:'application/json',
      data:table,
      success: function(json) {
        if(json.etat == true)
        {
          localStorage.setItem('url_domain', url_domain);
          localStorage.setItem('token', json.token);
          localStorage.setItem('idcontact', json.idcontact);
          localStorage.setItem('contact', json.contact);
          localStorage.setItem('idsite', json.idsite);
          location.reload();
        }
        else{
          console.log(json.max_terminal);
          console.log(json.max_terminal == true);
          if(json.max_terminal == true)
          {
            $('#msg_alert_login').show().html('<b>'+UIText.text_erreur+' !</b> '+UIText.text_limite_connexion);
          }
          else{
            $('#msg_alert_login').show().html('<b>'+UIText.text_erreur+' !</b> '+UIText.text_identifiant_incorrect);
          }
        }
        $('.div_loader').css('display', 'none');
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $('#msg_alert_login').show().html('<b>'+UIText.text_erreur+' !</b> '+UIText.text_verifier_internet);
        $('.div_loader').css('display', 'none');
      },
    });
    $('.div_loader').css('display', 'none');
  }
  else{
    $('#msg_alert_login').show().html('<b>'+UIText.text_erreur+' !</b> '+UIText.text_remplir_champs);
    $('.div_loader').css('display', 'none');
  }
}

export async function setSitesList() {
  $('.div_loader').css('display', 'flex');

  var idcontact = localStorage.getItem('idcontact');
  var token = localStorage.getItem('token');
  var url_domain = localStorage.getItem('url_domain');
  var href = url_domain+"sites";

  var table = {
    idcontact: idcontact,
    token : token,
  };

  $.ajax({
    type: "GET",
    dataType: 'jsonp',
    url: href,
    cors: true ,
    contentType:'application/json',
    data:table,
    success: function(json) {
      if(json.etat == true)
      {

        var sites = $('#list_sites');
        sites.empty();
        sites.append('<option value=""></option>');

        $.each(json.ugs, function(index, ug) {
          sites.append('<optgroup label="'+ ug.libelle + '">');

          $.each(ug.sites, function(index_site, site) {
            sites.append('<option value="'+ site.id +'">'+ site.libelle +'</option>');
          });

          sites.append('<optgroup/>');
        });

        if(localStorage.getItem('idsite') != null)
        {
          sites.val(localStorage.getItem('idsite'));
          $('#list_sites').trigger('change');
        }
        else{
          $('.div_loader').css('display', 'none');
        }

      }
      else{
        console.log('erreur récupération des sites');
        localStorage.removeItem('contact');
        localStorage.removeItem('idcontact');
        localStorage.removeItem('token');
        localStorage.removeItem('url_domain');
        localStorage.removeItem('card');
        localStorage.removeItem('point_accueil');
        localStorage.removeItem('idsite');
        localStorage.removeItem('idsalle');
        localStorage.removeItem('place_parking');
        location.reload();
      }
    }
  });

}

export async function setSallesList(show_all,_callback) {
  $('.div_loader').css('display', 'flex');

  var idcontact = localStorage.getItem('idcontact');
  var token = localStorage.getItem('token');
  var url_domain = localStorage.getItem('url_domain');
  var href = url_domain+"salles";

  var idsite = $('#list_sites').val();

  var nb_invite = 0;

  mailboxItem.requiredAttendees.getAsync(function (asyncResult) {
    if (asyncResult.status == Office.AsyncResultStatus.Failed){
      console.log(asyncResult.error.message);
    }
    else {
      nb_invite += asyncResult.value.length;
      mailboxItem.optionalAttendees.getAsync(function (asyncResult) {
        if (asyncResult.status == Office.AsyncResultStatus.Failed){
          console.log(asyncResult.error.message);
        }
        else {
          nb_invite += asyncResult.value.length;

          mailboxItem.start.getAsync(
            function (asyncResult) {
              if (asyncResult.status == Office.AsyncResultStatus.Failed){
                console.log(asyncResult.error.message);
              }
              else {

                var startdate = asyncResult.value.toString();
                startdate = startdate.substring(0, startdate.indexOf('GMT')+3);
                startdate = Date.parse(startdate)/1000;

                $('#date').html(asyncResult.value.toLocaleDateString());

                mailboxItem.end.getAsync(
                  function (asyncResult) {
                    if (asyncResult.status == Office.AsyncResultStatus.Failed){
                      console.log(asyncResult.error.message);
                    }
                    else {

                      var enddate = asyncResult.value.toString();
                      enddate = enddate.substring(0, enddate.indexOf('GMT')+3);
                      enddate = Date.parse(enddate)/1000;

                      mailboxItem.recurrence.getAsync(function(asyncResult) {
                        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                          var recurrence = asyncResult.value;
                          recurrence = JSON.stringify(recurrence);

                          if(recurrence != 'null')
                          {
                            $('#msg_alert').show().html(UIText.text_extension_gere_pas_recurrence);
                            $('#salle_dispo').hide();
                            $('#salle_non_dispo').hide();

                            if (typeof _callback === 'function')
                              _callback();

                            $('.div_loader').css('display', 'none');
                          }
                          else
                          {
                            $('#msg_alert').hide().html('');

                            var table = {
                              idcontact: idcontact,
                              token : token,
                              idsite : idsite,
                              startdate : startdate,
                              enddate : enddate,
                              nb_invite : nb_invite,
                              show_all : show_all,
                            };

                            $.ajax({
                              type: "GET",
                              dataType: 'jsonp',
                              url: href,
                              cors: true ,
                              contentType:'application/json',
                              data:table,
                              success: function(json) {
                                if(json.etat == true)
                                {

                                  if(json.salles.disponible.length == 0 && json.salles.non_disponible.length == 0)
                                  {
                                    $('#msg_alert').show().html(UIText.text_pas_de_salles_disponibles);
                                    $('#salle_dispo').hide();
                                    $('#salle_non_dispo').hide();
                                  }
                                  else{
                                    $('#msg_alert').hide().html('');
                                  }

                                  if(json.salles.disponible.length != 0 )
                                  {
                                    $('#salle_dispo').show();
                                    $('#list_salle_dispo').html(listSalleToHtml(json.salles.disponible));
                                  }
                                  else{
                                    $('#salle_dispo').hide();
                                  }

                                  if(json.salles.non_disponible.length != 0 )
                                  {
                                    $('#salle_dispo').show();
                                    $('#list_salle_non_dispo').html(listSalleToHtml(json.salles.non_disponible));
                                  }
                                  else{
                                    $('#salle_non_dispo').hide();
                                  }

                                  if(json.show_all == 1){
                                    $('#show_all_salles').hide();
                                  }
                                  else{
                                    $('#show_all_salles').show();
                                  }

                                  salleList = json;
                                }
                                else{
                                  console.log('erreur récupération des salles');
                                  localStorage.removeItem('contact');
                                  localStorage.removeItem('idcontact');
                                  localStorage.removeItem('token');
                                  localStorage.removeItem('url_domain');
                                  localStorage.removeItem('card');
                                  localStorage.removeItem('point_accueil');
                                  localStorage.removeItem('idsite');
                                  localStorage.removeItem('idsalle');
                                  localStorage.removeItem('place_parking');
                                  location.reload();
                                }

                                if (typeof _callback === 'function')
                                  _callback();

                                $('.div_loader').css('display', 'none');
                              }
                            });

                          }

                        } else {
                          console.error(asyncResult.error);
                        }
                      });
                    }
                  });
              }
            });


        }
      });

    }
  });

}

function listSalleToHtml(list_salles){
  var html_salles = "";

  $.each(list_salles, function(index, salle) {
    html_salles += '<div class="card">';

    if(salle.photo1 != null)
    {
      html_salles += '<div class="div_img_salle"><img class="img_salle" src="'+decodeURIComponent(salle.photo1)+'"></div>';
    }
    else
    {
      html_salles += '<div class="div_img_salle"><img class="img_salle" src="../../assets/img/default-room.jpg"></div>';
    }

    html_salles += '<div class="div_description">';

    html_salles += '<div class="div_places">' + salle.capacite + ' '+UIText.text_places+' / ' + salle.superficie +'</div>';

    if(salle.favoris == 1)
    {
      html_salles += '<img class="img_favoris" src="../../assets/img/favoris.png">';
    }

    html_salles += '<div class="div_libelle_salle">'+salle.nom+'</div>';

    html_salles += '<div class="div_accessoire align_center">';

    if(salle.acces_call_conference == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/call-conference.png">';

    if(salle.acces_ordinateur == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/ordinateur.png">';

    if(salle.acces_paperboard == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/paperboard.png">';

    if(salle.acces_point_eau == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/eau.png">';

    if(salle.acces_tab_blanc_interactif == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/tableauinteractif.png">';

    if(salle.acces_telephone == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/telephone.png">';

    if(salle.acces_video_proj == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/videopro.png">';

    if(salle.acces_visio_conference == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/videoconference.png">';

    if(salle.acces_televiseur == 1)
      html_salles += '<img class="icon_accessoire" src="../../assets/img/tele.png">';

    html_salles +='</div>';

    html_salles += '<table id="table_disponibilite"><tr><td colspan="13">'+UIText.text_disponibilites+' :</td></tr><tr>';

    for(var i = 7; i <=13; i++)
    {
      if(salle.disponibilite[i] == 1)
      {
        html_salles += '<td><span class="dot_green" >'+i+'</span></td>';
      }
      else
      {
        html_salles += '<td><span class="dot_red" >'+i+'</span></td>';
      }
    }

    html_salles += '</tr><tr>';

    for(var i = 14; i <=20; i++)
    {
      if(salle.disponibilite[i] == 1)
      {
        html_salles += '<td><span class="dot_green" >'+i+'</span></td>';
      }
      else
      {
        html_salles += '<td><span class="dot_red" >'+i+'</span></td>';
      }
    }

    html_salles += '</tr></table>';

    html_salles += '</div>';

    html_salles += '<button class="btn_reserver" data-idsalle="'+salle.id+'">'+UIText.text_reserver+'</button>';

    html_salles += '</div>';
  });

  return html_salles;
}

function setFilteredSallesList() {
  var filtered_salle = JSON.parse(JSON.stringify(salleList));

  filtered_salle.salles.disponible = $.grep(filtered_salle.salles.disponible, function(salle,index) {

    if ($('#filtre_call_conference').prop('checked') == true && salle.acces_call_conference == 0)
      return false;

    if ($('#filtre_ordinateur').prop('checked') == true && salle.acces_ordinateur == 0)
      return false;

    if ($('#filtre_paperboard').prop('checked') == true && salle.acces_paperboard == 0)
      return false;

    if ($('#filtre_eau').prop('checked') == true && salle.acces_point_eau == 0)
      return false;

    if ($('#filtre_tableauinteractif').prop('checked') == true && salle.acces_tab_blanc_interactif == 0)
      return false;

    if ($('#filtre_telephone').prop('checked') == true && salle.acces_telephone == 0)
      return false;

    if ($('#filtre_videopro').prop('checked') == true && salle.acces_video_proj == 0)
      return false;

    if ($('#filtre_videoconference').prop('checked') == true && salle.acces_visio_conference == 0)
      return false;

    if ($('#filtre_tele').prop('checked') == true && salle.acces_televiseur == 0)
      return false;

    return true;
  });

  filtered_salle.salles.non_disponible = $.grep(filtered_salle.salles.non_disponible, function(salle,index) {

    if ($('#filtre_call_conference').prop('checked') == true && salle.acces_call_conference == 0)
      return false;

    if ($('#filtre_ordinateur').prop('checked') == true && salle.acces_ordinateur == 0)
      return false;

    if ($('#filtre_paperboard').prop('checked') == true && salle.acces_paperboard == 0)
      return false;

    if ($('#filtre_eau').prop('checked') == true && salle.acces_point_eau == 0)
      return false;

    if ($('#filtre_tableauinteractif').prop('checked') == true && salle.acces_tab_blanc_interactif == 0)
      return false;

    if ($('#filtre_telephone').prop('checked') == true && salle.acces_telephone == 0)
      return false;

    if ($('#filtre_videopro').prop('checked') == true && salle.acces_video_proj == 0)
      return false;

    if ($('#filtre_videoconference').prop('checked') == true && salle.acces_visio_conference == 0)
      return false;

    if ($('#filtre_tele').prop('checked') == true && salle.acces_televiseur == 0)
      return false;

    return true;
  });



  if(filtered_salle.salles.disponible.length == 0 && filtered_salle.salles.non_disponible.length == 0)
  {
    $('#msg_alert').show().html('Pas de salle disponible.');
    $('#salle_dispo').hide();
    $('#salle_non_dispo').hide();
  }
  else{
    $('#msg_alert').hide().html('');
  }

  if(filtered_salle.salles.disponible.length != 0 )
  {
    $('#salle_dispo').show();
    $('#list_salle_dispo').html(listSalleToHtml(filtered_salle.salles.disponible));
  }
  else{
    $('#salle_dispo').hide();
  }

  if(filtered_salle.salles.non_disponible.length != 0 )
  {
    $('#salle_dispo').show();
    $('#list_salle_non_dispo').html(listSalleToHtml(filtered_salle.salles.non_disponible));
  }
  else{
    $('#salle_non_dispo').hide();
  }

  if(filtered_salle.show_all == 1){
    $('#show_all_salles').hide();
  }
  else{
    $('#show_all_salles').show();
  }
}

function resetFiltres() {
  $( ".filtre" ).each(function() {
    $( this ).prop('checked', false);
  });
}

function getDateAsync(dateProp, cb) {
  // dateProp peut être un Date, ou un objet avec getAsync, ou autre
  if (dateProp instanceof Date) {
    return cb(null, dateProp);
  }
  if (dateProp && typeof dateProp.getAsync === "function") {
    return dateProp.getAsync((res) => {
      if (res.status !== Office.AsyncResultStatus.Succeeded) return cb(res.error);
      cb(null, res.value); // res.value est un Date
    });
  }
  cb(new Error("start/end indisponible dans ce contexte (probablement MessageRead)."));
}